<template>
  <div class="casebanner">
    <div class="bannerbg">
      <img src="../../../assets/case/ydybn_sample.png" alt="" />
      <div class="btn">在线咨询</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scope>
.casebanner {
  width: 1920px;
  height: 520px;
  margin: 0 auto;
  position: relative;
  .bannerbg {
    position: absolute;
    top: 0;
    left: 0;
    img {
      width: 100%;
      height: 100%;
    }
    .btn {
      color: #2670d5;
      font-weight: bold;
      font-size: 20px;
      width: 120px;
      text-align: center;
      padding: 6px 0;
      border-radius: 40px;
      background-color: #fff;
      position: absolute;
      top: 63%;
      right: 44%;
    }
  }
}
</style>